import { render } from "./ownUserLocationDepartmentSelect.html?vue&type=template&id=d22507c4&ts=true&external"
import script from "./ownUserLocationDepartmentSelect.ts?vue&type=script&lang=ts&external"
export * from "./ownUserLocationDepartmentSelect.ts?vue&type=script&lang=ts&external"

import "./ownUserLocationDepartmentSelect.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__